import { OlssConnectionType } from '@app/pages/openlab-systems/add-openlab-system-component';
import { OpenLabSystem } from '@app/api/openlab-system-api.service';

export default {
    getOlssConnectionTypes(serverFQDN: string) {
        if (!serverFQDN) {
            return [];
        }
        const periodIndex = serverFQDN.indexOf('.');
        const hostname = serverFQDN.substring(0, periodIndex);
        const hostnameConnType: OlssConnectionType = {
            name: 'hostname',
            value: hostname
        };

        const fqdnConnectionType = {
            name: 'fqdn',
            value: serverFQDN
        };
        return [hostnameConnType, fqdnConnectionType];
    },

    getOlssConnectionString(olssServer: OpenLabSystem) {
        return this.getOlssConnectionTypes(olssServer?.olss_server)
            .find(type => type.name === olssServer?.olss_connection_type).value;
    }
};
